// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"8932228b","297":"719def75","643":"a09ad6b9","787":"2996537e"}[chunkId] + ".chunk.js";
};